import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import GameStart from "../../utils/GameStart";
import UserInput from "./UserInput";
import toast, { Toaster } from "react-hot-toast";
import Button from "react-bootstrap/esm/Button";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import BackToGameList from "../../utils/BackToGameList";

const default_lines = [{ start: "", finishLine: "" }];

function FinishLine(props) {
  const [gameOver, setGameOver] = useState(false);
  const [count, setCount] = useState(0);
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [resetGame, setResetGame] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [selectedGame, setSelectedGame] = useState();
  const [openGameStartModal, setOpenGameStartModal] = useState();
  const [gameSelect, setGameSelect] = useState([]);
  const [finishLine, setFinishLine] = useState([
    {
      difficulty: 0,
      finishLine: "a",
    },
  ]);
  const [userDifficulty, setUserDifficulty] = useState({
    guess_count: 3,
  });
  const [guessesCount, setGuessesCount] = useState(userDifficulty.guess_count);

  const handleFinishLineData = async () => {
    const getGame = gameSelect.findIndex((item) => item.id === selectedGame);
    setFinishLine(gameSelect[getGame].finish_lines);
  };

  const handleGameSelect = async () => {
    const response = await makeGetRequest(
      urls.finishLine + "?active=True",
      "",
      true
    );
    setGameSelect(response.data);
  };

  useEffect(() => {
    if (selectedGame) {
      handleFinishLineData();
    }
  }, [selectedGame]);

  useEffect(() => {
    handleGameSelect();
  }, []);

  useEffect(() => {
    handleResetGame(resetGame);
  }, [resetGame]);

  const handleResetGame = (trigger) => {
    if (trigger === 1) {
      setCount(0);
      setGameOver(false);
      setSelectedGame();
      setFinishLine([
        {
          difficulty: 0,
          finishLine: "",
        },
      ]);
    }
  };
  const handleGuess = (userFinishLine) => {
    if (guessesCount > 1) {
      if (
        userFinishLine !== "" ||
        userFinishLine !== null ||
        userFinishLine !== "undefined"
      ) {
        if (
          userFinishLine.toLowerCase() ===
          finishLine[count].finishLine.toLowerCase()
        ) {
          toast(
            "That is correct! The answer is: " +
              finishLine[count].start +
              " " +
              finishLine[count].finishLine,
            {
              duration: 6000,
              position: "bottom-center",
            }
          );
          setGuessesCount(userDifficulty.guess_count);
          setGameOver(true);
        } else {
          if (userFinishLine === "") {
            toast("Please enter a guess.", {
              duration: 2000,
              position: "bottom-center",
            });
          } else {
            setGuessesCount((prevCount) => {
              return prevCount - 1;
            });
            toast(
              "That is incorrect. You have " +
                (guessesCount - 1) +
                " guesses remaining.",
              {
                duration: 2000,
                position: "bottom-center",
              }
            );
          }
        }
      }
    } else {
      setGuessesCount((prevCount) => {
        return prevCount - 1;
      });
      toast(
        "Nice try, but you've run out of guesses. Would you like to try again, or move to the next Finish Line?",
        {
          duration: 6000,
          position: "bottom-center",
        }
      );
      setGameOver(true);
    }
  };

  const tryAgain = () => {
    setGuessesCount(userDifficulty.guess_count);
    setGameOver(false);
  };

  const nextQuestion = () => {
    setGuessesCount(userDifficulty.guess_count);
    setGameOver(false);
    if (count >= finishLine.length - 1) {
      setTimesPlayed((prevCount) => prevCount + 1);
      setOpenGameStartModal(true);
    } else {
      setCount((prevCount) => prevCount + 1);
    }
  };

  return (
    <>
      <BackToGameList />
      <GameStart
        check={props.errorCheck}
        timer={props.timerCheck}
        onStartTime={setTriggerTimer}
        setTime={setTime}
        openGameStartModal={openGameStartModal}
        timesPlayed={timesPlayed}
        setResetGame={setResetGame}
        onGameStartModal={setOpenGameStartModal}
        gameTitle={"Finish Line"}
        gameDescription={`To play, touch the "Start Game" button. 
        Then click on the card to reveal the line, and then click again to reveal the finish.`}
        setSelectedGame={setSelectedGame}
        gameSelect={gameSelect}
      />
      <Container style={{ marginTop: "50px" }}>
        <Toaster />
        <Card>
          <Row>
            <Card.Body style={{ fontSize: "45px" }} id="title">
              {finishLine[count].start}...
            </Card.Body>
          </Row>
          <Row>
            {!gameOver && (
              <UserInput
                gameOver={gameOver}
                lineStart={finishLine.start}
                handleGuess={handleGuess}
                guessesCount={guessesCount}
              />
            )}
            {gameOver && (
              <>
                <Row>
                  <Col>
                    {" "}
                    {guessesCount === 0 ? (
                      <>
                          <Row>
                            <h2>
                              Nice try, but you've run out of guesses. 
                              <br />
                              Would you like to try again, or move to the next Finish Line?"
                            </h2>
                          </Row>
                          <Row>
                            <Col>
                              <Button variant="warning" onClick={tryAgain}>Try Again...</Button>
                            </Col>
                            <Col></Col>
                            <Col>
                              <Button onClick={nextQuestion}>Next Question...</Button>
                            </Col>
                          </Row>
                        </>
                      
                    ) : <>
                          <Row>
                            <h2>
                              That is correct! The answer is: {finishLine[count].start} <b>{finishLine[count].finishLine}</b>
                            </h2>
                          </Row>
                          <Row>
                            <Col></Col>
                            <Col></Col>
                            <Col>
                              <Button onClick={nextQuestion}>Next Question...</Button>
                            </Col>
                          </Row>
                        </>
                    }
                    
                  </Col>
                </Row>
              </>
            )}
            <div style={{ textAlign: "right", paddingRight: "40px" }}>
              {count + 1} / {finishLine.length}
            </div>
          </Row>
        </Card>
      </Container>
    </>
  );
}

export default FinishLine;
